import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LazyLoadImageModule } from 'ng-lazyload-image';
//// columns
import { ColumnComponent, ColumnGroupComponent, ColumnListComponent } from './columns/column/column.component';
import { ColumnSearchComponent } from './columns/column/column-search.component';
import { FormTitleComponent } from './columns/title/title.component';
import { FormReadonlyComponent } from './columns/readonly/readonly.component';
import { FormLabelComponent } from './columns/readonly/label.component';
import { FormLabelDirective } from './columns/readonly/label.directive';
import { FormImgComponent } from './columns/img/img.component';
import { FormImgService } from './columns/img/img.service';
import { FormLinkComponent } from './columns/link/link.component';
import { FormButtonComponent } from './columns/button/button.component';
import { FormCopyComponent } from './columns/copy/copy.component';
import { HiddenComponent } from './columns/hidden/hidden.component';
import { TextComponent } from './columns/text/text.component';
import { TextAreaComponent } from './columns/textarea/textarea.component';
import { NumberComponent } from './columns/number/number.component';
import { EmailComponent } from './columns/email/email.component';
import { DateTimeComponent } from './columns/date/datetime.component';
import { MonthComponent } from './columns/date/month.component';
import { SelectComponent } from './columns/select/select.component';
import { Select2Component } from './columns/select/select2.component';
import { Select2AjaxComponent } from './columns/select/select2ajax.component';
import { Select2ajaxService } from './columns/select/select2ajax.service';
import { RadioComponent } from './columns/radio/radio.component';
import { CheckboxComponent } from './columns/checkbox/checkbox.component';
import { OneCheckboxComponent } from './columns/checkbox/one-checkbox.component';
import { FileComponent } from './columns/file/file.component';
import { FileService } from './columns/file/file.service';
import { FileInfoComponent } from './columns/file/file-info.component';
import { ZipComponent } from './columns/zip/zip.component';
import { ZipService } from './columns/zip/zip.service';
import { PlaceholderDirective } from './columns/placeholder/placeholder.directive';
import { ColumnDirective } from './columns/column/column.directive';
import { ColumnService } from './columns/column/column.service';
import { ReadonlyService } from './columns/readonly/readonly.service';
import { ColumnBaseService } from './columns/base/columnbase.service';
import { TextOperatorComponent } from './columns/operator/text-operator.component';
import { RangeOperatorComponent } from './columns/operator/range-operator.component';
import { LabelOperatorComponent } from './columns/operator/label-operator.component';
import { HtmlEditorComponent } from './columns/html/html-editor.component';
import { CLEditorComponent } from './columns/html/cleditor.component';
import { CLEditorService } from './columns/html/cleditor.service';
import { DisplayTargetComponent } from './columns/target/target.component';
import { DisplayTargetService } from './columns/target/target.service';
import { ColorComponent } from './columns/color/color.component';
//// other items
import { AnchorComponent } from './anchor/anchor.component';
import { PLabelComponent } from './label/plabel.component';
import { SpanLabelComponent } from './label/spanlabel.component';
import { ButtonComponent } from './button/button.component';
import { ButtonDirective } from './button/button.directive';
//// kts
import { KtsTaskConditionComponent } from '../projects/kts/items/columns/task/task-condition.component';
import { KtsTaskConditionService } from '../projects/kts/items/columns/task/task-condition.service';
import { KtsTaskLabelComponent } from '../projects/kts/items/columns/task/task-label.component';
import { KtsConstructionClassificationComponent } from '../projects/kts/items/columns/construction-classification/construction-classification.component';
import { KtsConstructionClassificationLabelComponent } from '../projects/kts/items/columns/construction-classification/construction-classification-label.component';
import { KtsConstructionClassificationService } from '../projects/kts/items/columns/construction-classification/construction-classification.service';
import { KtsDepartmentComponent } from '../projects/kts/items/columns/department/department.component';
import { KtsDepartmentLabelComponent } from '../projects/kts/items/columns/department/department-label.component';
import { KtsDepartmentService } from '../projects/kts/items/columns/department/department.service';
import { KtsFileInfoComponent } from '../projects/kts/items/columns/file/file-info.component';
import { KtsFileDownloadComponent } from '../projects/kts/items/columns/file/file-download.component';
import { KtsRadioVerticalComponent } from '../projects/kts/items/columns/radio-vertical/radio-vertical.component';
import { KtsPickadateComponent } from '../projects/kts/items/columns/date/pickadate.component';
import { KtsFlatpickrComponent } from '../projects/kts/items/columns/date/flatpickr.component';
import { KtsDateComponent } from '../projects/kts/items/columns/date/date.component';
import { KtsTimeComponent } from '../projects/kts/items/columns/date/time.component';
import { KtsDateTimeComponent } from '../projects/kts/items/columns/date/datetime.component';
import { KtsDateTimeService } from '../projects/kts/items/columns/date/datetime.service';
var ItemsModule = /** @class */ (function () {
    function ItemsModule() {
    }
    ItemsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, FormsModule, LazyLoadImageModule],
                    declarations: [
                        //// kts
                        KtsTaskConditionComponent,
                        KtsTaskLabelComponent,
                        KtsConstructionClassificationComponent,
                        KtsConstructionClassificationLabelComponent,
                        KtsDepartmentComponent,
                        KtsDepartmentLabelComponent,
                        KtsFileInfoComponent,
                        KtsFileDownloadComponent,
                        KtsRadioVerticalComponent,
                        KtsPickadateComponent,
                        KtsFlatpickrComponent,
                        KtsDateComponent,
                        KtsTimeComponent,
                        KtsDateTimeComponent,
                        //// ma31
                        //// columns
                        ColumnComponent,
                        ColumnListComponent,
                        ColumnGroupComponent,
                        ColumnSearchComponent,
                        FormTitleComponent,
                        FormReadonlyComponent,
                        FormLabelComponent,
                        FormLabelDirective,
                        FormImgComponent,
                        FormLinkComponent,
                        FormButtonComponent,
                        FormCopyComponent,
                        HiddenComponent,
                        TextComponent,
                        TextAreaComponent,
                        NumberComponent,
                        EmailComponent,
                        DateTimeComponent,
                        MonthComponent,
                        SelectComponent,
                        Select2Component,
                        Select2AjaxComponent,
                        RadioComponent,
                        CheckboxComponent,
                        OneCheckboxComponent,
                        FileComponent,
                        FileInfoComponent,
                        ZipComponent,
                        TextOperatorComponent,
                        RangeOperatorComponent,
                        LabelOperatorComponent,
                        HtmlEditorComponent,
                        CLEditorComponent,
                        DisplayTargetComponent,
                        ColorComponent,
                        PlaceholderDirective,
                        ColumnDirective,
                        //// other items
                        AnchorComponent,
                        PLabelComponent,
                        SpanLabelComponent,
                        ButtonComponent,
                        ButtonDirective,
                    ],
                    entryComponents: [],
                    exports: [
                        //// kts
                        KtsTaskConditionComponent,
                        KtsTaskLabelComponent,
                        KtsConstructionClassificationComponent,
                        KtsConstructionClassificationLabelComponent,
                        KtsDepartmentComponent,
                        KtsDepartmentLabelComponent,
                        KtsFileInfoComponent,
                        KtsFileDownloadComponent,
                        KtsRadioVerticalComponent,
                        KtsPickadateComponent,
                        KtsFlatpickrComponent,
                        KtsDateComponent,
                        KtsTimeComponent,
                        KtsDateTimeComponent,
                        //// ma31
                        //// columns
                        ColumnComponent,
                        ColumnListComponent,
                        ColumnGroupComponent,
                        ColumnSearchComponent,
                        FormTitleComponent,
                        FormReadonlyComponent,
                        FormLabelComponent,
                        FormImgComponent,
                        FormLinkComponent,
                        FormButtonComponent,
                        FormCopyComponent,
                        HiddenComponent,
                        TextComponent,
                        TextAreaComponent,
                        NumberComponent,
                        EmailComponent,
                        DateTimeComponent,
                        MonthComponent,
                        SelectComponent,
                        Select2Component,
                        Select2AjaxComponent,
                        RadioComponent,
                        CheckboxComponent,
                        OneCheckboxComponent,
                        FileComponent,
                        FileInfoComponent,
                        ZipComponent,
                        TextOperatorComponent,
                        RangeOperatorComponent,
                        LabelOperatorComponent,
                        HtmlEditorComponent,
                        CLEditorComponent,
                        DisplayTargetComponent,
                        ColorComponent,
                        ColumnDirective,
                        //// other items
                        AnchorComponent,
                        PLabelComponent,
                        SpanLabelComponent,
                        ButtonComponent,
                        ButtonDirective,
                    ],
                    providers: [
                        //// kts
                        KtsTaskConditionService,
                        KtsConstructionClassificationService,
                        KtsDepartmentService,
                        KtsDateTimeService,
                        //// ma31
                        ColumnService,
                        ColumnBaseService,
                        ReadonlyService,
                        FormImgService,
                        Select2ajaxService,
                        FileService,
                        ZipService,
                        DisplayTargetService,
                        CLEditorService,
                    ]
                },] }
    ];
    return ItemsModule;
}());
export { ItemsModule };
//# sourceMappingURL=items.module.js.map